<template>
<b-tab lazy title-item-class="mr-1" :title-link-class="{'bg-danger': hasErrors, 'bg-warning': isDirty}">
    <template slot="title">
        <i v-if="isDirty || hasErrors" class="fa-solid fa-circle-exclamation" :class="{ 'fa-circle-exclamation text-white': hasErrors, 'fa-cloud-arrow-up text-black': isDirty}"></i> Vaccinations
    </template>
    <vaccinations-base button-top small fixed :callback="createPatientAdminVaccination" />
</b-tab>
</template>
<script>
import TabExtension from "../TabExtension"
import VaccinationsBase from '@/core/components/vaccinations/VaccinationsBase'
import { mapActions } from "vuex"

export default TabExtension.extend({
    name: "vaccinations",
    components: {
        'vaccinations-base': VaccinationsBase
    },
    methods: {
        ...mapActions('vaccinations', ['createPatientAdminVaccination']),
    }
})
</script>